import { FileResource } from '../item/model/FileResource'
import { FileViewerType, getFileViewerTypeFromURL } from './FileType'
import { UnsupportedViewer } from './viewers/UnsupportedViewer'
import { ImageViewer } from './viewers/ImageViewer'
import { PdfViewer } from './viewers/PdfViewer'
import LoadingSpinner from '../genericComponents/LoadingSpinner'
import { Typography } from '../genericComponents/typographie/UIKitV2/Typography'
import './FileViewerDialog.scss'
import {setSnackbarMessage} from '../genericComponents/commonSlice'
import {useDispatch} from 'react-redux'

export const FileViewer = (
    {
        file,
        isFetching,
        onClose
    }
:{
    file: FileResource | undefined,
    isFetching: boolean,
    onClose: () => void 
}) => {

    const dispatch = useDispatch()

    const currentFileViewerType = getFileViewerTypeFromURL(file?.uri || '')

    if (!currentFileViewerType && !isFetching) {
        onClose()
        dispatch(setSnackbarMessage('Invalid file URL'))
    }

    if (isFetching) {
        return <div className="file-viewer-loading">
                <Typography>Fetching File...</Typography>
                <LoadingSpinner />
            </div>
    }

    if (file) {
        switch (currentFileViewerType) {
            case FileViewerType.IMAGE:
                return <ImageViewer file={file} />
            case FileViewerType.PDF:
                return <PdfViewer file={file} />
            default:
                return <UnsupportedViewer file={file} onClose={onClose} />
        }
    }

    else {
        return <div>
            <Typography className="failure-file-text">Fail to get file</Typography>
        </div>
    }
}